<div class="np-rows" data-testid="nav-plan-normal-container">
  <div class="np-plan-rows-outer">
  @if (!hudBottomOpened && !isDragging) {
    <app-navigation-plan-row
      [computer]="closedComputer"
      (batteryReservedWarningClick)="onBatteryReservedWarning()"
      data-testid="nav-plan-row-closed">
    </app-navigation-plan-row>
  }

  @if (hudBottomOpened || isDragging) {
    @for (computerElement of computersArray; track computerElement.Type; let i = $index) {
      <app-navigation-plan-row
        [computer]="computerElement"
        (batteryReservedWarningClick)="onBatteryReservedWarning()"
        [attr.data-testid]="'nav-plan-row-item-' + i">
      </app-navigation-plan-row>
    }
    @if (computersArray.length === 0) {
      <app-navigation-plan-row data-testid="nav-plan-row-empty"></app-navigation-plan-row>
    }
  }
  </div>

  @if (hudBottomOpened || isDragging) {
    <div class="np-actions" (click)="$event.stopPropagation()" data-testid="nav-plan-normal-actions-container">
      @if (computersArray.length > 0 && computersArray[0].Type == 'wp') {
        <button class="ev-button primary" (click)="onSkipWaypoint()" data-testid="nav-plan-normal-skip-waypoint-btn">
          {{ languageService.languageJSON.Global_Skip }}
        </button>
      }
      @if (computersArray.length > 0 && computersArray[0].Type == 'cs') {
        <button class="ev-button primary"
          [ngClass]="{'inactive': cannotSkipMoreChargingStation}"
          (click)="onSkipChargingStation()" data-testid="nav-plan-normal-skip-charging-btn">
          {{ languageService.languageJSON.Global_Skip }}
        </button>
      }
      <button class="ev-button" (click)="onStopNavigation()" data-testid="nav-plan-normal-stop-btn">
        {{ languageService.languageJSON.Global_Stop }}
      </button>
    </div>
  }
</div>
